import React, { useEffect, useState } from "react";
import axiosInstance from "../api/axiosInstance";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
export default function RequestedMedicines() {

  const [orders, setOrders] = useState([]);
  const [files, setFiles] = useState({});
  const [selected, setSelected] = useState({});
  const [uploading, setUploading] = useState(false);
  const [sentOrders, setSentOrders] = useState([]);
const [lockedOrders, setLockedOrders] = useState({});
const navigate = useNavigate();

const isLocked = (order) => {
  return (
    localStorage.getItem(`rx_locked_${order.id}`) === "true" ||
    order.rx_status === "submitted" ||
    order.rx_status === "approved"
  );
};
  /* ================= LOAD ORDERS ================= */

  const loadOrders = async () => {
    try {
      const res = await axiosInstance.get("/orders/requested/");
      setOrders(res.data);
    } catch {
      Swal.fire({
    icon: "error",
    title: "Failed",
    text: "Unable to load orders"
  });
    }
  };

  useEffect(() => {
    loadOrders();
  }, []);









  /* ================= LOAD PRESCRIPTIONS ================= */

  const loadPrescriptions = async (orderId) => {

    if (!orderId) return;

    try {

      const res = await axiosInstance.get(
        `/orders/prescriptions/${orderId}/`
      );

      setFiles(prev => ({
        ...prev,
        [orderId]: res.data
      }));

    } catch {

      console.log("No files yet");

    }
  };

useEffect(() => {

  const interval = setInterval(() => {
    loadOrders();
  }, 30000);

  return () => clearInterval(interval);

}, []);

  useEffect(() => {

    orders.forEach(order => {
      loadPrescriptions(order.id);
    });

  }, [orders]);


  /* ================= FILE SELECT ================= */

  const handleSelect = (orderId, e) => {

    setSelected(prev => ({
      ...prev,
      [orderId]: Array.from(e.target.files)
    }));

  };


  /* ================= UPLOAD ================= */

  const uploadFiles = async (orderId) => {

    if (!orderId) {
      Swal.fire({
    icon: "error",
    title: "Invalid Order"
  });
      return;
    }

    if (!selected[orderId]?.length) {
      Swal.fire({
    icon: "warning",
    title: "No Files Selected",
    text: "Please select prescription files first"
  });
      return;
    }

    const form = new FormData();

    form.append("order_id", orderId);

    selected[orderId].forEach(file => {
      form.append("file", file);
    });


    try {

      setUploading(true);

      await axiosInstance.post(
        "/orders/upload-prescription/",
        form,
        {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      );

      Swal.fire({
  icon: "success",
  title: "Uploaded Successfully",
  text: "Prescription uploaded"
});
  


      setSelected(prev => ({
        ...prev,
        [orderId]: []
      }));

      loadPrescriptions(orderId);
      loadOrders();


    } catch (err) {

      console.error(err);
      Swal.fire({
  icon: "error",
  title: "Upload Failed",
  text: "Please try again"
});

    } finally {

      setUploading(false);

    }
  };


  /* ================= DELETE ================= */

  const deleteFile = async (id, orderId) => {

    const result = await Swal.fire({
  title: "Delete File?",
  text: "This action cannot be undone",
  icon: "warning",
  showCancelButton: true,
  confirmButtonColor: "#dc2626",
  cancelButtonColor: "#6b7280",
  confirmButtonText: "Delete"
});

if (!result.isConfirmed) return;

    await axiosInstance.delete(
      `/orders/prescription/${id}/delete/`
    );

    loadPrescriptions(orderId);

  };


  /* ================= SEND ================= */

const submitForReview = async (orderId) => {

  try {

    await axiosInstance.post(
      "/orders/submit-prescription/",
      { order_id: orderId }
    );

    // ✅ Mark as sent
    setSentOrders(prev => ({
      ...prev,
      [orderId]: true
    }));
localStorage.setItem(`rx_locked_${orderId}`, "true");
    Swal.fire({
  icon: "success",
  title: "Prescription Sent",
  text: "Check WhatsApp and App notifications"
});

    loadOrders();

  } catch (err) {

    Swal.fire({
  icon: "error",
  title: "Submission Failed",
  text:
    err.response?.data?.error ||
    "Please try again"
});

  }
};
const canUpload = (order) => {
  return order.items.some(item =>
    ["pending_upload", "pending_review"].includes(item.status)
  );
};
const getPendingItems = (order) => {
  return order.items.filter(item =>
    ["pending_upload", "pending_review"].includes(item.status)
  );
};

const getDeliveryMessage = (order) => {

  // Store pickup
  if (order.delivery === 0 && order.items.some(i => i.status === "store_pickup")) {
    return "🏬 Store pickup selected. No delivery charges.";
  }

  // Delivery pending admin quote
  if (order.delivery === 0 && order.rx_status === "approved") {
    return "⏳ Delivery charges will be updated soon by admin. You will be notified.";
  }

  // Delivery confirmed
  if (order.delivery > 0) {
    return "✅ Delivery charges confirmed.";
  }

  return null;
};


  /* ================= UI ================= */

  return (

    <div style={styles.container}>
<button
  onClick={() => navigate("/customer-dashboard")}
  style={{
    marginBottom: "15px",
    padding: "8px 14px",
    background: "#2563eb",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
  }}
>
  ⬅ Back to Dashboard
</button>

      <h2 style={styles.title}>
        Requested Medicines
      </h2>


      {orders.length === 0 && (
        <p>No pending requests</p>
      )}


      {orders.map(order => (

        <div key={order.id} style={styles.card}>


          {/* ===== ORDER HEADER ===== */}

          <h4>Order #{order.id}</h4>

          <div style={styles.priceBox}>

  <p>Items: ₹{order.cart_total}</p>

  <p>Delivery: ₹{order.delivery}</p>

  <b>Total: ₹{order.payable}</b>


  {/* ✅ DELIVERY MESSAGE */}
  {getDeliveryMessage(order) && (

    <div style={{
      marginTop: 8,
      fontSize: 13,
      background: "#fff7ed",
      padding: 6,
      borderRadius: 5,
      color: "#9a3412"
    }}>

      {getDeliveryMessage(order)}

    </div>

  )}

</div>



          {/* ===== ITEMS ===== */}

          {order.items.map((item, i) => (

            <div key={i} style={styles.itemRow}>

              <b>{item.name}</b>

              <div style={styles.smallText}>
                Qty: {item.qty} × ₹{item.price}
              </div>

              <div style={styles.smallText}>
                Subtotal: ₹{item.subtotal}
              </div>

              <div style={styles.status}>
                {item.status}
              </div>

            </div>

          ))}


{/* ===== UPLOAD ===== */}
{canUpload(order) && (
  <>
    <hr />

    <h4>📄 Upload Prescription For:</h4>

    <ul style={{ fontSize: 13 }}>
      {getPendingItems(order).map(i => (
        <li key={i.name}>{i.name}</li>
      ))}
    </ul>

    {/* Hidden Gallery/PDF Input */}
    <input
      id={`file-${order.id}`}
      type="file"
      multiple
      disabled={isLocked(order)}
      accept="image/*,.pdf"
      onChange={(e) => handleSelect(order.id, e)}
      style={{ display: "none" }}
    />

    {/* Hidden Camera Input */}
    <input
      id={`camera-${order.id}`}
      type="file"
      accept="image/*"
      capture="environment"
      disabled={isLocked(order)}
      onChange={(e) => handleSelect(order.id, e)}
      style={{ display: "none" }}
    />

    {/* Buttons Row */}
    <div style={{ display: "flex", justifyContent: "center", gap: 10, marginTop: 10 }}>

      {/* Choose File Button */}
      <button
        disabled={isLocked(order)}
        style={{
          ...styles.chooseBtn,
          background:
            isLocked(order) ? "#9ca3af" : "#22c55e",
          cursor:
            isLocked(order)
              ? "not-allowed"
              : "pointer",
          opacity:
            isLocked(order) ? 0.6 : 1
        }}
        onClick={() =>
          document.getElementById(`file-${order.id}`).click()
        }
      >
        📎 Choose File
      </button>



    </div>





          {/* Selected Preview */}
          {selected[order.id]?.length > 0 && (

            <div style={styles.selectedBox}>

              <b>Selected:</b>

              {selected[order.id].map((f, i) => (

                <div key={i}>
                  📄 {f.name}
                </div>

              ))}

            </div>

          )}


          {/* Upload */}
         <button
  onClick={() => uploadFiles(order.id)}
  disabled={uploading || isLocked(order)}
>
  Upload 
</button>



          {/* Add More */}
{files[order.id]?.length > 0 &&
 !isLocked(order) && (

  <p
    style={{
      color: "#2563eb",
      cursor: "pointer",
      marginTop: 8
    }}
    onClick={() =>
      document.getElementById(`file-${order.id}`).click()
    }
  >
    ➕ Attach another file
  </p>

)}




          {/* ===== UPLOADED FILES ===== */}

          <h4>Uploaded Files</h4>

          {files[order.id]?.map(f => (

            <div key={f.id} style={styles.fileRow}>


              {/* Preview */}
              {f.url.match(/\.(jpg|jpeg|png)$/i) ? (

                <img
                  src={f.url}
                  alt=""
                  style={styles.previewImg}
                />

              ) : (

                <a href={f.url} target="_blank">
                  📄 {f.name}
                </a>

              )}


              {/* Delete */}
<button
  onClick={() => deleteFile(f.id, order.id)}
  disabled={isLocked(order)}
  style={{
width: "40px",
    height: "40px",
    background:
      isLocked(order) ? "#9ca3af" : "red",
    color: "#fff",
    border: "none",
    padding: "4px 8px",
    borderRadius: "50%",
    cursor:
      isLocked(order)
        ? "not-allowed"
        : "pointer",
   fontSize: "18px",
   flexShrink: 0,
    opacity:
      isLocked(order) ? 0.6 : 1
  }}
>
  ❌
</button>



            </div>

          ))}


          {/* ===== SEND ===== */}
{files[order.id]?.length > 0 && (

  <>

 {!isLocked(order) ? (

  <button
    onClick={() => submitForReview(order.id)}
    className="btn btn-primary"
  >
    📤 Send to Pharmacist
  </button>

) : (

  <div style={{
    background: "#e5e7eb",
    padding: 10,
    borderRadius: 6,
    textAlign: "center",
    marginTop: 10
  }}>
    ✅ Sent <br/>
    🙏 Thanks for sharing the prescription. Our pharmacist will contact you soon 🙏
  </div>

)}


  </>

)}

</>

)}
        </div>

      ))}

    </div>
  );
}



/* ================= STYLES ================= */

const styles = {

  container: {
    maxWidth: 500,
    margin: "auto",
    padding: 10
  },

  title: {
    textAlign: "center",
    marginBottom: 20
  },

  card: {
    border: "1px solid #ddd",
    borderRadius: 10,
    padding: 12,
    marginBottom: 25,
    background: "#fff"
  },

  priceBox: {
    background: "#f0fdf4",
    padding: 10,
    borderRadius: 6,
    border: "1px solid #86efac",
    marginBottom: 12,
    fontSize: 14
  },

  itemRow: {
    borderBottom: "1px dashed #ccc",
    padding: "6px 0"
  },

  smallText: {
    fontSize: 13
  },

  status: {
    fontSize: 13,
    color: "#555"
  },

  chooseBtn: {
    width: "100%",
    padding: 8,
    marginBottom: 8,
    borderRadius: 5
  },

  uploadBtn: {
    width: "100%",
    background: "#16a34a",
    color: "#fff",
    padding: 8,
    border: "none",
    borderRadius: 5,
    marginTop: 6
  },

  selectedBox: {
    fontSize: 13,
    background: "#f9fafb",
    padding: 6,
    borderRadius: 5,
    marginBottom: 6
  },

  addMore: {
    color: "#2563eb",
    cursor: "pointer",
    fontSize: 13
  },

  fileRow: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "20px",
    border: "1px solid #ddd",
    padding: "10px",
    borderRadius: "8px",
    marginBottom:"8px"
  },

  previewImg: {
  width: 100,
  height: 100,
  objectFit: "contain",
  borderRadius: 8,
  background: "#fff"
},


  sendBtn: {
    width: "100%",
    background: "#2563eb",
    color: "#fff",
    padding: 10,
    border: "none",
    borderRadius: 6,
    marginTop: 10
  }

};
